/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useEffect } from "react";

import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

function FactorsHallmarks() {
	const { currentStep, countryBrandApplication, update, formRef, setPreviousStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const { factorsHallmarksComment } = countryBrandApplication;

	useEffect(() => {
		setPreviousStep(currentStep - 1);
		const submitStepData = () => {
			const factorsHallmarksComment = formRef.current.elements.comment?.value;

			update({
				data: {
					factorsHallmarksComment,
				},
				nextStep: currentStep + 1,
			});
		};
		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, []);

	return (
		<div className="step-page" id="step-13">
			<section>
				<h3>15 - Factores distintivos de la empresa que representen a Uruguay</h3>
				<label htmlFor="comment">
					Especificar por ejemplo productos insignia o servicios que su mejor consideración
					representen a Uruguay y a quienes o en qué momento es brindado.
					<textarea rows="5" name="comment" defaultValue={factorsHallmarksComment} />
				</label>
			</section>
		</div>
	);
}

export { FactorsHallmarks };
